import { combineReducers } from 'redux';
import authReducer from '../features/auth/authReducer';
import adReducer from '../features/inventory/adReducer';
import placementReducer from '../features/inventory/placementReducer';
import settingsReducer from '../features/settings/settingsReducer';
import apiKeyReducer from '../features/settings/apiKeyReducer';

const rootReducer = combineReducers({
  auth: authReducer,
  ads: adReducer,
  placements: placementReducer,
  settings: settingsReducer,
  apiKeys: apiKeyReducer,
});

export default rootReducer;